import { render } from "./Jsjb.vue?vue&type=template&id=4de18219&scoped=true"
import script from "./Jsjb.vue?vue&type=script&lang=js"
export * from "./Jsjb.vue?vue&type=script&lang=js"

import "./Jsjb.vue?vue&type=style&index=0&id=4de18219&scoped=true&lang=css"

import exportComponent from "E:\\IdeaProjects\\jgwgxt-qt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4de18219"]])

export default __exports__